import { colorPalette } from "@elastic/eui";

export const _colors={destacado:'#9170B8', inicial:'#ebedf1'}
//olorPalette([,], 2);

export const createOptions = (data:any) =>{
  return data.map((u: any)=> { return { label: u.nombre, value: u.login, color:_colors.inicial} })
}

export const customSelection = (data:any) =>{
  Array.isArray(data) && data.map((d:any,i:number)=>{d.color=(i===0?_colors.destacado: _colors.inicial);})
}